import { z } from "zod";

export const UnreportedMachineProductEntitySchema = z.object({
  id: z.number(),
  companyId: z.number(),
  companyName: z.string().nullable().optional(),
  reportingRouterId: z.number(),
  machineName: z.string(),
  machineDescription: z.string().nullable().optional(),
  snmpRawDataViewUrl: z.string().nullable().optional(),
  snmpRawDataDownloadUrl: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
});

export type UnreportedMachineProductEntity = z.infer<
  typeof UnreportedMachineProductEntitySchema
>;